export default "/images/1787085513eeff3f3c989620a29f08a8.avif";